import React from "react";
import UserGreenIcon from "../Common/svg/usergreenicon";
import PhoneIcon from "../Common/svg/phoneicon";
import LocationSvg from "../Common/svg/locationGray";
import EmailIcon from "../Common/svg/emailicon";
import { useNavigate } from "react-router-dom";

const CustomerInfo = ({ orderData }) => {
  const navigate = useNavigate();
  const order = orderData?.data?.order;
  const user = order?.user;

  if (!order || !user) {
    return (
      <div className="col-md-4">
        <div className="card rounded-4 shadow-sm">
          <div className="card-body">
            <div className="d-flex align-items-center gap-2 mb-3">
              <UserGreenIcon />
              <h5 className="text-smoke font16 font700">معلومات العميل</h5>
            </div>
            <div className="text-center text-muted py-3">
              لا توجد بيانات عميل متاحة
            </div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="col-md-4">
      <div className="card rounded-4 shadow-sm">
        <div className="card-body">
          <div className="d-flex align-items-center justify-content-between">
            <div className="d-flex align-items-center gap-2">
              <UserGreenIcon />
              <h5 className="text-smoke font16 font700">معلومات العميل</h5>
            </div>

            <button
              data-tooltip-id="show"
              className="btn btn-primary p-1"
              onClick={() =>
                navigate(`${process.env.PUBLIC_URL}/user/${user.id}`)
              }
            >
              المزيد
            </button>
          </div>
          <ul className="d-flex flex-column gap-2 mt-2">
            <div>
              <h6 className="text-gray">الإسم</h6>
              <h6 className="text-smoke">{user.name || "غير محدد"}</h6>
            </div>
            <li className="d-flex align-items-center gap-1">
              <PhoneIcon />{" "}
              <span className="text-smoke">{user.phone || "غير محدد"}</span>
            </li>
            {user.email && (
              <li className="d-flex align-items-center gap-1">
                <EmailIcon /> <span className="text-smoke">{user.email}</span>
              </li>
            )}
            {user.address && (
              <li className="d-flex align-items-center gap-1">
                <LocationSvg />{" "}
                <span className="text-smoke">{user.address}</span>
              </li>
            )}
            {user.id && (
              <li className="d-flex align-items-center gap-1">
                <span className="text-gray">رقم العميل:</span>
                <span className="text-smoke">{user.id}</span>
              </li>
            )}
          </ul>
        </div>
      </div>
    </div>
  );
};

export default CustomerInfo;
